'use client'

import { Skeleton } from 'shared/antd'

import { useGetCategoriesQuery } from 'modules/Category/model/api'
import { CategoryCard } from 'modules/Category/ui/CategoryCard/universal'

import styles from './CategoryList.module.scss'

export function CategoryList() {
  const { data: categories, isLoading } = useGetCategoriesQuery({})

  if (!isLoading && !categories?.length) return null

  if (isLoading) {
    return (
      <div className={styles.wrapper}>
        {Array.from({ length: 12 }).map((_, index) => (
          <Skeleton key={index} width={'100%'} height={115} />
        ))}
      </div>
    )
  }

  return (
    <div className={styles.wrapper}>
      {categories?.map(({ name, image, id, slug, is_hidden }) => {
        if (is_hidden) return null

        return (
          <CategoryCard
            type="mobile"
            key={id}
            title={name}
            image={image}
            slug={slug}
          />
        )
      })}
    </div>
  )
}
